import { Empty, List, Modal, Pagination, Spin, Switch, Typography } from 'antd';

import { formatLeadListTime } from '@app/components/LeadCard/utils/formatLeadListTime';
import {
  useNotificationsListModal,
  usePopupNotificationsSetting,
} from '@app/shared/components/NotificationsBell/hooks';

import type { FC } from 'react';

import '@app/shared/components/NotificationsBell/styles/NotificationsBell.scss';

const { Text } = Typography;

interface NotificationsListModalProps {
  open: boolean;
  onClose: () => void;
}

export const NotificationsListModal: FC<NotificationsListModalProps> = ({
  open,
  onClose,
}) => {
  const { items, totalCount, page, pageSize, isFetching, isError, setPage } =
    useNotificationsListModal(open);
  const { isEnabled, changeEnabled, isSaving, isReady } =
    usePopupNotificationsSetting();

  return (
    <Modal
      data-testid="notifications-list-modal"
      title="Уведомления"
      open={open}
      onCancel={onClose}
      footer={null}
      className="notifications-list-modal"
    >
      {/* Всплывающий тост нового уведомления можно отключить; счётчик на
          колокольчике и этот список работают независимо от переключателя.
          До загрузки матрицы настроек (isReady) свич заблокирован — иначе
          переключение некуда сохранять. */}
      <label className="notifications-list-popup-setting">
        <Switch
          size="small"
          checked={isEnabled}
          disabled={!isReady}
          loading={isSaving}
          onChange={changeEnabled}
          data-testid="notifications-popup-enabled"
        />
        <Text>Отображение всплывающих уведомлений</Text>
      </label>
      <Spin spinning={isFetching}>
        {isError ? (
          <Empty
            data-testid="notifications-list-error"
            description="Не удалось загрузить уведомления"
          />
        ) : items.length ? (
          <>
            <List
              data-testid="notifications-list"
              dataSource={items}
              renderItem={(item) => (
                <List.Item
                  key={item.Id}
                  className="notifications-list-item"
                  data-testid="notifications-list-item"
                >
                  <div className="notifications-list-item-header">
                    <Text strong>{item.Title}</Text>
                    <Text
                      type="secondary"
                      className="notifications-list-item-date"
                    >
                      {formatLeadListTime(item.CreatedAt)}
                    </Text>
                  </div>
                  <Text type="secondary">{item.Message}</Text>
                </List.Item>
              )}
            />
            {totalCount > pageSize && (
              <Pagination
                data-testid="notifications-list-pagination"
                className="notifications-list-pagination"
                current={page}
                pageSize={pageSize}
                total={totalCount}
                onChange={setPage}
                showSizeChanger={false}
              />
            )}
          </>
        ) : (
          !isFetching && (
            <Empty
              data-testid="notifications-list-empty"
              description="Уведомлений пока нет"
            />
          )
        )}
      </Spin>
    </Modal>
  );
};
